<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <div class="chip-icon small primary">
      <div class="inner"><i class="ti ti-file"></i></div>
    </div>
    <span class="title ms-2">Extraire les informations salariés </span>
  </div>
  <button class="button m icon transparent" (click)="close()"><i class="ti ti-x"></i></button>
</div>
<div class="modal-content">
  <form [formGroup]="exportForm" class="d-flex flex-column gap-3 w-100">
    <div class="d-flex flex-column gap-2 form-group flex-grow-1">
      <label>Format de l'extraction</label>
      <div class="d-flex flex-row gap-2 align-items-center">
        <label class="radio">
          Excel (.xlsx)<input class="ms-2" type="radio" formControlName="format" value="xlsx">
        </label>
        <label class="radio">
          PDF<input class="ms-2" type="radio" formControlName="format" value="pdf">
        </label>
      </div>
      <label class="mt-2">Champs à extraire</label>
      <div class="row fields" formGroupName="fields">
        <div class="col d-flex flex-column gap-2">
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="id"> Numéro d'adhérent
          </label>
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="firstname"> Nom
          </label>
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="lastname"> Prénom
          </label>
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="coverage"> Statut
          </label>
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="startDate"> Date de début
          </label>
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="endDate"> Date de fin
          </label>
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="beneficiariesCount"> Nombre de bénéficiaires
          </label>
        </div>
        <div class="col d-flex flex-column gap-2">
          <p><em>L'export de ces données augmentera le temps de génération du fichier</em></p>
          <!--          <label class="checkbox">-->
          <!--            <input class="me-2" type="checkbox" formControlName="employerPremium"> Cotisation employeur-->
          <!--          </label>-->
          <!--          <label class="checkbox">-->
          <!--            <input class="me-2" type="checkbox" formControlName="employeePremium"> Cotisation salarié-->
          <!--          </label>-->
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="contract"> Contrat
          </label>
          <label class="checkbox" *ngIf="env.config?.memberDetails?.showCotisations">
            <input class="me-2" type="checkbox" formControlName="totalPremium"> Total cotisation
          </label>
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="beneficiaryType"> Type de bénéficiaire
          </label>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer d-flex flex-row align-items-center justify-content-end gap-2">
  <button class="button m" (click)="close()" type="button">Annuler</button>
  <button class="button m primary confirm" (click)="export()" type="button">Confirmer<ion-spinner *ngIf="loading"
      color="light" name="dots"></ion-spinner></button>
</div>